import type { TableProps } from 'antd';
import type { PropsWithChildren } from 'react';

import { StyledTable } from './table.style';

export const Table = (props: PropsWithChildren<TableProps<any>>) => <StyledTable {...props} />;
